import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentWrapper: {
      padding: theme.spacing(15),
      boxSizing: 'content-box',
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(10),
      },
    },
    contentContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  })
);
